export default "__VITE_ASSET__C2RhzwFg__"